<template>
    <el-drawer v-model="logview" size="90%" direction="rtl" :before-close="handleClose">
        <span class="er-renew-goods-title">商品置顶历史记录</span>
        <div class="TTL-table top40">
            <el-table :data="loglist" stripe="true" empty-text="" >
                <template v-slot:empty><el-empty description="暂无数据"></el-empty></template>
                <el-table-column prop="id" label="id" align="center" min-width="100"/>
                <el-table-column prop="renewname" label="置顶名称" align="center" min-width="150"/>
                <el-table-column prop="area_type" label="作用范围" align="center" min-width="150"/>
                <el-table-column label="首页期初时长" align="center" min-width="150">
                    <template #default="scope">
                        <span>{{scope.row.idx_start_num=='' ? '/' : scope.row.idx_start_num}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="订阅/退订时长" align="center" min-width="150">
                    <template #default="scope">
                        <span>{{scope.row.idx_nums=='' ? '/' : scope.row.idx_nums}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="首页结余时长" align="center" min-width="150">
                    <template #default="scope">
                        <span>{{scope.row.idx_end_num=='' ? '/' : scope.row.idx_end_num}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="首页置顶时间范围" align="center" min-width="280">
                    <template #default="scope">
                        <span>{{scope.row.endtime==''? '/' : scope.row.begintime+' ~ '+scope.row.endtime}}</span>
                    </template>
                </el-table-column>

                <el-table-column label="列表期初时长" align="center" min-width="150">
                    <template #default="scope">
                        <span>{{scope.row.list_start_num=='' ? '/' : scope.row.list_start_num}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="订阅/退订时长" align="center" min-width="150">
                    <template #default="scope">
                        <span>{{scope.row.list_num=='' ? '/' : scope.row.list_num}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="列表结余时长" align="center" min-width="150">
                    <template #default="scope">
                        <span>{{scope.row.list_end_num=='' ? '/' : scope.row.list_end_num}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="列表置顶时间范围" align="center" min-width="280">
                    <template #default="scope">
                        <span>{{scope.row.listtopend==''? '/' : scope.row.listtopbegin+' ~ '+scope.row.listtopend}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="期初金额" align="center" min-width="150">
                    <template #default="scope">
                        <span>{{scope.row.begin_price==0 ? '/' : scope.row.begin_price}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="订阅/退订金额" align="center" min-width="150">
                    <template #default="scope">
                        <span>{{scope.row.price==0 ? '/' : '￥'+scope.row.price}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="结余金额" align="center" min-width="150">
                    <template #default="scope">
                        <span>{{scope.row.end_price==0 ? '/' : '￥'+scope.row.end_price}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="关联支付单号" align="center" min-width="150">
                    <template #default="scope">
                        <span>{{scope.row.transition_sn}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作时间" align="center" min-width="150">
                    <template #default="scope">
                        <span>{{scope.row.inputtime}}</span>
                    </template>
                </el-table-column>
            </el-table>
        </div>
    </el-drawer>
</template>

<script>
import INTERFACE_MODEL_RENEW from '@/Interface/Es/Renew';
export default {
    props:['view','value'],
    data() {
        return {
            logview:false,
            goodsid:'',
            loglist:[],
        }
    },
    watch: {
        view(val){
            if(val) {
                this.logview=true;
                this.goodsid=this.value;
                this.GetRenewGoodsLog(this.goodsid);
            }
        },
    },
    mounted() {
        
    },
    methods: {

        /** 获取商品置顶记录 **/
        GetRenewGoodsLog(goodsid) {
            INTERFACE_MODEL_RENEW.GET_RENEW_DETAIL_GOODS_LOG({goodsid:goodsid}).then((res) => {
                 if(res.status > 0) return false;
                 this.loglist=res.data;
            });
        },


        /** 关闭窗口 **/
        handleClose() {
            this.logview=false;
            this.$emit('finish');
        },

    },
}
</script>
<style scoped>
.auth-box {display: inline-block;width:100%;}
.auth-box-item {display: inline-flex;align-items: center;width:100%;position:relative;}
.auth-title {display: inline-flex;align-items: center;font-size:16px;font-weight: bold;}
.auth-title span {font-size:12px;line-height: 12px;color:#666666;padding:4px 10px;border-radius: 20px;border:1px solid #666666;font-weight: normal;}
.auth-status {color:#ffffff !important;background-color: #666eeb;border-color:#666eeb !important;}
.auth-box-content-title {display: inline-block;font-size:13px;color:#333333;width:25%;}
.auth-box-content {display: inline-block;font-size:13px;color:#333333;}
.auth-error {font-size:13px;color:red !important;border:none !important;}
.TTL-btn-box {display: inline-flex;justify-content: flex-end;align-items: center;width:100%;margin-bottom:20px;}
.er-renew-goods-title {display: inline-block;width:100%;font-size:16px;font-weight: bold;color:#333333;}
</style>